<p-table [value]="templates">
    <ng-template pTemplate="header">
        <tr>
            <th>
                ID
            </th>
            <th>
                Name
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>
                {{template.id}}
            </td>
            <td>
                <a (click)="selectTemplateToEdit(template)" class="template-select-link">
                    <p>Pre confirmation template {{template.language.name}}</p>
                </a>
            </td>
        </tr>
    </ng-template>
</p-table>